import { c as _c } from "react/compiler-runtime";
import { useStripeProducts } from "@hooks/use-stripe-products";
import { CREDIT_PACKAGES } from "@src/constants/credit-constants";
import { appStateSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";
import { isProductionEnvironment } from "@utils/env-utils";
import { convertStripeProductToCreditPackage } from "@utils/stripe-product-utils";
/**
 * @returns Whether tokens can be purchased through Stripe checkout,
 * which is only available with alpha testing outside production.
 * TODO: Enable when Stripe payment is released https://faro01.atlassian.net/browse/ST-3105
 */
export function useIsStripePurchaseEnabled() {
  const {
    isAlphaTestingEnabled
  } = useAppSelector(appStateSelector);
  return isAlphaTestingEnabled && !isProductionEnvironment;
}

/**
 * A hook that returns the token packages to offer.
 * These are the Stripe products when Stripe purchase is enabled,
 * otherwise the static packages for requesting a quote.
 */
export function useCreditPackages() {
  const $ = _c(8);
  const isStripePurchaseEnabled = useIsStripePurchaseEnabled();
  let t0;
  if ($[0] !== isStripePurchaseEnabled) {
    t0 = {
      isEnabled: isStripePurchaseEnabled
    };
    $[0] = isStripePurchaseEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    stripeProducts,
    isLoading
  } = useStripeProducts(t0);
  if (!isStripePurchaseEnabled) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        creditPackages: CREDIT_PACKAGES,
        isLoading: false
      };
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== stripeProducts) {
    t1 = stripeProducts.map(convertStripeProductToCreditPackage);
    $[3] = stripeProducts;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isLoading || $[6] !== t1) {
    t2 = {
      creditPackages: t1,
      isLoading
    };
    $[5] = isLoading;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}